import React, { useEffect, useMemo } from "react";
import ThreadHelper from "../../../../entities/thread/thread-helper";
import { EventEmitter } from "../../../../shared/utils/event-emitter";
import Events from "../../../../const/events";
import { Tooltip } from "react-tooltip";

const ChatMessage = ({ message, selectedThread, direction, previousMessage }) => {
  const [shouldGroupMessage, setShouldGroupMessage] = React.useState(false);
  const _showQRPopup = () => {
    EventEmitter.dispatch(Events.SHOW_QR_CODE_POPUP, {
      id: message?._by?._id,
      title: message?._by?.name,
    });
  };

  const leftChatColorClass = useMemo(() => {
    let colorClass = "yellow";
    // Check if thread type is room
    if (selectedThread?.type === "room" && selectedThread?._contacts) {
      // Now check if message is sent by selectedThread._contacts[0]._id
      if (message?._by?._id === selectedThread?._contacts[0]?._id) {
        colorClass = "orange";
      } else {
        colorClass = "yellow";
      }
    }
    return colorClass;
  }, []);


  useEffect(() => {
    if (previousMessage?.msgType === 'messages' && message?.msgType === 'messages' && previousMessage?._by?._id && message?._by?._id && (previousMessage?._by?._id === message?._by?._id)) {
      setShouldGroupMessage(true);
    }
  }, [previousMessage])


  if (message.msgType !== "messages") {
    const cleanSystemMessage = (text) =>
      text
        .replace(/\*Notification from [^*]+\*\s*/i, '')
        .replace(/\s*sent to .+$/i, '')
        .trim();

    const SystemNotificationCard = ({ msg }) => (
      <div style={{ marginBottom: '8px', display: 'flex', justifyContent: 'center', padding: '0 16px' }}>
        <div style={{
          background: '#f8faff',
          border: '1px solid #e0e7ff',
          borderRadius: '8px',
          padding: '7px 12px',
          maxWidth: '480px',
          width: '100%',
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
            <i className="mdi mdi-bell-outline" style={{ fontSize: '13px', color: '#4f46e5', flexShrink: 0 }}></i>
            <div style={{
              display: 'inline-block',
              background: '#4f46e5',
              color: '#ffffff',
              fontSize: '10px',
              fontWeight: '700',
              padding: '1px 7px',
              borderRadius: '20px',
              letterSpacing: '0.3px',
              flexShrink: 0,
            }}>
              SYSTEM
            </div>
            <div style={{ fontSize: '12px', color: '#374151', flex: 1, lineHeight: '1.4' }}>
              {cleanSystemMessage(msg.message)}
            </div>
          </div>
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            fontSize: '11px',
            color: '#9ca3af',
            marginTop: '5px',
            paddingTop: '5px',
            borderTop: '1px solid #f3f4f6',
          }}>
            <p style={{ margin: 0 }}>→ {msg?._by?.name || 'Unknown'}</p>
            <p style={{ margin: 0 }}>{ThreadHelper.getFormattedDateTime(msg.createdAt, true)}</p>
          </div>
        </div>
      </div>
    );

    // System message
    if (selectedThread?.type === "room") {
      return <SystemNotificationCard msg={message} />;
    } else {
      return <SystemNotificationCard msg={message} />;
    }
  }
  // console.log('11111222', message?.metadata)
  return (
    <>
      {direction === "outgoing" ? (
        <div className="media">
          <div className="media-img reverse">
            <span className="fullName">{message._by.email}</span>
            <div className="avatar-box thumb-sm align-self-center">
              <span
                className="thumb-sm justify-content-center d-flex align-items-center bg-soft-primary rounded-circle"
                onClick={_showQRPopup}
              >
                d
              </span>
            </div>
          </div>
          <div className="media-body reverse">
            <div className={`chat-msg ${message?.metadata?.ai_filtered ? 'ai-flagged' : ''}`}>
              <p>
                {message.message}
                {message?.metadata?.ai_filtered && (
                  <span className="ai-flag-indicator" data-tooltip-id="ai-flag-tooltip">
                    <i className="fa fa-shield-alt"></i>
                  </span>
                )}
                <span className="timestamp">
                  {ThreadHelper.getFormattedDateTime(message.createdAt, true)}
                  <span className="status">
                    {message.status === "read" ? (
                      <span className="read" title="Read at 12:00 pm">
                        <i className="fa fa-check-double"></i>
                      </span>
                    ) : message.status === "queued" ? (
                      <span className="queued" title="Queued">
                        <i className="fa fa-clock"></i>
                      </span>
                    ) : (
                      <span className="notRead" title="Delivered">
                        <i className="fa fa-check"></i>
                      </span>
                    )}
                  </span>
                </span>
              </p>
            </div>
          </div>
        </div>
      ) : (
        <div className={`media ${leftChatColorClass}`}>  {/* orange for who starts the convo & yellow for the other person */}
          {
            shouldGroupMessage ? <></> : (
              <div className="media-img">
                {/* <div className="avatar-box thumb-sm align-self-center">
                  <span
                    className="thumb-sm justify-content-center d-flex align-items-center bg-soft-primary rounded-circle"
                    onClick={_showQRPopup}
                  >
                    {message?._by?.name ? message?._by?.name[0] : "U"}
                  </span>
                </div> */}
                <span className="fullName">
                  <span className="viaIcon whatsapp"><i className="fab fa-whatsapp"></i></span>
                  {message?._by?.name}
                </span>
              </div>
            )
          }

          <div className="media-body">
            <div className={`chat-msg ${message?.metadata?.ai_filtered ? 'ai-flagged' : ''}`}>
              <p>
                {message.message}
                {message?.metadata?.ai_filtered && (
                  <span className="ai-flag-indicator" data-tooltip-id="ai-flag-tooltip">
                    <i className="fa fa-shield-alt"></i>
                  </span>
                )}
                <span className="timestamp">
                  {ThreadHelper.getFormattedDateTime(message.createdAt, true)}
                  {message?.byType === "Contact" && (
                    <span className="status">
                      {message.status === "read" ? (
                        <span className="read" title="Read">
                          <i className="fa fa-check-double"></i>
                        </span>
                      ) : message.status === "queued" ? (
                        <span className="queued" title="Queued">
                          <i className="fa fa-clock"></i>
                        </span>
                      ) : (
                        <span className="notRead" title="Delivered">
                          <i className="fa fa-check"></i>
                        </span>
                      )}
                    </span>
                  )}
                </span>
              </p>
            </div>
            {/* <div className="chat-msg">
              <p>
                There are many variations of passages of Lorem Ipsum available.
                <span className="timestamp">2:30pm</span>
              </p>
            </div> */}
          </div>
        </div>
      )}
      {message?.metadata?.ai_filtered && (
        <Tooltip id="ai-flag-tooltip" place="bottom">
          This message was filtered by AI and not forwarded as it violates organization policies
        </Tooltip>
      )}
    </>
  );
};

export default ChatMessage;
